import { Spinner as NextUISpinner } from '@heroui/spinner';
import { extendVariants } from '@heroui/react';

export const Spinner = extendVariants(NextUISpinner, {
  variants: {
    color: {
      zoomapp: {
        circle1: 'border-4 border-b-grey-400',
        circle2: 'border-4 border-b-grey-400',
      },
      default: {
        circle1: 'border-b-default-300',
        circle2: 'border-b-default-300',
      }
    }
  }
});
